import DisclosureEx from "@components/DisclosureEx";
import React from "react";
import {useFormUserProfile, UserForm} from "../../hooks/useFormUserProfile";
import {UpdateUserResult} from "@commons/actions/user.action";
import {toast} from "react-toastify";
import {useAppDispatch} from "@hooks/redux-hooks/hooks";
import {waitingForActivation} from "@commons/core.slice";
import {useFormChangePassword} from "../../hooks/useFormChangePassword";
import {ChangePasswordForm} from "../../features/signIn/NewPassword";
import {FormProvider} from "react-hook-form";

export const UserProfilePage: React.FC = () => {
    const dispatch = useAppDispatch();
    const _onSuccess = (payload: UpdateUserResult) => {
        toast('Profilo utente aggiornato!', {type: 'success'});
        if (payload.tokenVerificaEmail) {
            toast('Ti abbiamo inviato una nuova email!', {type: 'success'});
            dispatch(waitingForActivation(null));
        }
    }

    const {user, updateUser, useFormReturn} = useFormUserProfile(_onSuccess);
    const {handleSubmit, watch, formState: {errors}} = useFormReturn;

    const _onChangePasswordSuccess = (strMessage: string) => {
        toast(strMessage, {type: 'success'});
    }
    const _onChangePasswordError = (strMessage: string) => {
        toast(strMessage, {type: 'error'});
    }
    const {
        onSubmitHandler,
        useFormReturn: useChangePasswordFR,
    } = useFormChangePassword('byIdUser', _onChangePasswordSuccess, _onChangePasswordError);


    return <div className="bg-white rounded-md px-2 mt-4 py-5">

        <DisclosureEx accordionColor="bg-sky-400 hover:bg-sky-500" accordionTitle="Proprietà"
                      accordionState={true}
                      submitButtonText={<><span>Salva</span></>}
                      formSubmit={(e) => {
                          handleSubmit(updateUser)(e).catch(() => {
                          })
                      }}
        >
            <div className="space-y-4">
                <UserForm form={useFormReturn}/>
            </div>
        </DisclosureEx>

        <DisclosureEx accordionColor="bg-sky-400 hover:bg-sky-500" accordionTitle="Modifica la password di accesso a FPNet"
                      accordionState={true}
        >
            <FormProvider {...useChangePasswordFR} >
                <form className="space-y-4" onSubmit={onSubmitHandler}>
                    <ChangePasswordForm askEmail={false} askCurrentPassword={true}/>
                    <div className="flex justify-end mt-5 border-t border-gray-200 pt-5">
                        <button type="submit"
                                className="ml-3 inline-flex justify-center rounded-md border border-transparent bg-blue-600 p-1.5 sm:p-2 md:py-2 md:px-4 text-sm font-medium text-white shadow-sm
                                                    hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50">
                            Cambia password
                        </button>
                    </div>
                </form>
            </FormProvider>
        </DisclosureEx>
    </div>
        ;
}
export default UserProfilePage;